// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3cRjA","amount":"Amount_amount__Gdd7l","tip":"Amount_tip__3zroU","tipHeader":"Amount_tipHeader__2fhAR","tipsWrap":"Amount_tipsWrap__37olp"};